/**
 * Expose brand ratings on product tiles: * https:www.notion.so/faire/Low-lift-testing-Batch-2-cfd95df3dffe4210a9cf9ef8e68c6da4
 */
export const PRODUCT_TILE_BRAND_RATINGS_240826 = 'PRODUCT_TILE_BRAND_RATINGS_240826';
